// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"lWo2u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _searchModalScss = require("/src/scss/components/_search-modal.scss");
var _listJs = require("list.js");
var _listJsDefault = parcelHelpers.interopDefault(_listJs);
var _debounce = require("lodash/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
(()=>{
    const searchIcon = document.getElementById("search-icon");
    const panel = document.getElementById("search-modal");
    if (!searchIcon || !panel) return;
    const input = document.getElementById("search-modal-input");
    const resultsEl = document.getElementById("search-modal-results");
    const spinner = document.getElementById("search-modal-spinner");
    let searchList = null;
    function openSearch() {
        panel.hidden = false;
        searchIcon.setAttribute("aria-expanded", "true");
        if (!searchList) initSearchList();
        input.focus();
    }
    function closeSearch() {
        panel.hidden = true;
        searchIcon.setAttribute("aria-expanded", "false");
    }
    searchIcon.addEventListener("click", ()=>{
        if (panel.hidden) openSearch();
        else closeSearch();
    });
    // ESC schließt das Panel
    document.addEventListener("keydown", (event)=>{
        if (event.key === "Escape" && !panel.hidden) closeSearch();
    });
    // Klick außerhalb schließt das Panel (auch Klicks aufs SVG in der Lupe abfangen)
    document.addEventListener("click", (event)=>{
        if (panel.hidden) return;
        if (!panel.contains(event.target) && !searchIcon.contains(event.target)) closeSearch();
    });
    function initSearchList() {
        searchList = new (0, _listJsDefault.default)("search-modal-results", {
            valueNames: [
                {
                    attr: "href",
                    name: "url"
                },
                "title"
            ],
            item: `<li><a href="" class="url"><p class="title"></p></a></li>`
        }, []);
        input.addEventListener("input", (0, _debounceDefault.default)(async (event)=>{
            const value = event.target.value.trim();
            if (!value) {
                searchList.clear();
                resultsEl?.setAttribute("aria-busy", "false");
                return;
            }
            resultsEl?.setAttribute("aria-busy", "true");
            if (spinner) spinner.hidden = false;
            try {
                const res = await fetch(`/wp-json/wp/v2/search?search=${encodeURIComponent(value)}&per_page=20`);
                const data = await res.json();
                searchList.clear();
                if (data.length) data.forEach((result)=>{
                    searchList.add({
                        url: result.url,
                        title: result.title
                    });
                });
                else searchList.add({
                    title: "Keine Ergebnisse gefunden",
                    url: "#"
                });
            } catch (err) {
                console.error("Search error:", err);
                searchList.clear();
                searchList.add({
                    title: "Suche fehlgeschlagen. Bitte versuchen Sie es erneut.",
                    url: "#"
                });
            } finally{
                if (spinner) spinner.hidden = true;
                resultsEl?.setAttribute("aria-busy", "false");
            }
        }, 300));
    }
})();

},{"/src/scss/components/_search-modal.scss":"pNt2k","list.js":"2soMv","lodash/debounce":"i6S27","@parcel/transformer-js/src/esmodule-helpers.js":"7rQxk"}],"pNt2k":[function() {},{}],"2soMv":[function(require,module,exports,__globalThis) {
var naturalSort = require("1b434b5a9461d8e5"), getByClass = require("a756cccd66af1725"), extend = require("355c8271d6d86583"), indexOf = require("2cf6256fc694ce82"), events = require("8c38020246d086d2"), toString = require("d07d13fdc6dfa6a7"), classes = require("b22749e10068855f"), getAttribute = require("ddb7a930ed4b98df"), toArray = require("ab1cf05479417227");
module.exports = function(id, options, values) {
    var self = this, init, Item = require("594d6336bb7bad00")(self), addAsync = require("644da385e1a4c8fe")(self), initPagination = require("640d9f0a2c0d9b81")(self);
    init = {
        start: function() {
            self.listClass = 'list';
            self.searchClass = 'search';
            self.sortClass = 'sort';
            self.page = 10000;
            self.i = 1;
            self.items = [];
            self.visibleItems = [];
            self.matchingItems = [];
            self.searched = false;
            self.filtered = false;
            self.searchColumns = undefined;
            self.searchDelay = 0;
            self.handlers = {
                updated: []
            };
            self.valueNames = [];
            self.utils = {
                getByClass: getByClass,
                extend: extend,
                indexOf: indexOf,
                events: events,
                toString: toString,
                naturalSort: naturalSort,
                classes: classes,
                getAttribute: getAttribute,
                toArray: toArray
            };
            self.utils.extend(self, options);
            self.listContainer = typeof id === 'string' ? document.getElementById(id) : id;
            if (!self.listContainer) return;
            self.list = getByClass(self.listContainer, self.listClass, true);
            self.parse = require("d999c75a1dca2c51")(self);
            self.templater = require("165df06372153afc")(self);
            self.search = require("8c1b0467bbd8e450")(self);
            self.filter = require("2154e67e03c4e3ce")(self);
            self.sort = require("62d0ae838d4b984c")(self);
            self.fuzzySearch = require("9b29ed0a6fd5d4b5")(self, options.fuzzySearch);
            this.handlers();
            this.items();
            this.pagination();
            self.update();
        },
        handlers: function() {
            for(var handler in self.handlers)if (self[handler] && self.handlers.hasOwnProperty(handler)) self.on(handler, self[handler]);
        },
        items: function() {
            self.parse(self.list);
            if (values !== undefined) self.add(values);
        },
        pagination: function() {
            if (options.pagination !== undefined) {
                if (options.pagination === true) options.pagination = [
                    {}
                ];
                if (options.pagination[0] === undefined) options.pagination = [
                    options.pagination
                ];
                for(var i = 0, il = options.pagination.length; i < il; i++)initPagination(options.pagination[i]);
            }
        }
    };
    /*
   * Re-parse the List, use if html have changed
   */ this.reIndex = function() {
        self.items = [];
        self.visibleItems = [];
        self.matchingItems = [];
        self.searched = false;
        self.filtered = false;
        self.parse(self.list);
    };
    this.toJSON = function() {
        var json = [];
        for(var i = 0, il = self.items.length; i < il; i++)json.push(self.items[i].values());
        return json;
    };
    /*
   * Add object to list
   */ this.add = function(values, callback) {
        if (values.length === 0) return;
        if (callback) {
            addAsync(values.slice(0), callback);
            return;
        }
        var added = [], notCreate = false;
        if (values[0] === undefined) values = [
            values
        ];
        for(var i = 0, il = values.length; i < il; i++){
            var item = null;
            notCreate = self.items.length > self.page ? true : false;
            item = new Item(values[i], undefined, notCreate);
            self.items.push(item);
            added.push(item);
        }
        self.update();
        return added;
    };
    this.show = function(i, page) {
        this.i = i;
        this.page = page;
        self.update();
        return self;
    };
    /* Removes object from list.
   * Loops through the list and removes objects where
   * property "valuename" === value
   */ this.remove = function(valueName, value, options) {
        var found = 0;
        for(var i = 0, il = self.items.length; i < il; i++)if (self.items[i].values()[valueName] == value) {
            self.templater.remove(self.items[i], options);
            self.items.splice(i, 1);
            il--;
            i--;
            found++;
        }
        self.update();
        return found;
    };
    /* Gets the objects in the list which
   * property "valueName" === value
   */ this.get = function(valueName, value) {
        var matchedItems = [];
        for(var i = 0, il = self.items.length; i < il; i++){
            var item = self.items[i];
            if (item.values()[valueName] == value) matchedItems.push(item);
        }
        return matchedItems;
    };
    /*
   * Get size of the list
   */ this.size = function() {
        return self.items.length;
    };
    /*
   * Removes all items from the list
   */ this.clear = function() {
        self.templater.clear();
        self.items = [];
        return self;
    };
    this.on = function(event, callback) {
        self.handlers[event].push(callback);
        return self;
    };
    this.off = function(event, callback) {
        var e = self.handlers[event];
        var index = indexOf(e, callback);
        if (index > -1) e.splice(index, 1);
        return self;
    };
    this.trigger = function(event) {
        var i = self.handlers[event].length;
        while(i--)self.handlers[event][i](self);
        return self;
    };
    this.reset = {
        filter: function() {
            var is = self.items, il = is.length;
            while(il--)is[il].filtered = false;
            return self;
        },
        search: function() {
            var is = self.items, il = is.length;
            while(il--)is[il].found = false;
            return self;
        }
    };
    this.update = function() {
        var is = self.items, il = is.length;
        self.visibleItems = [];
        self.matchingItems = [];
        self.templater.clear();
        for(var i = 0; i < il; i++){
            if (is[i].matching() && self.matchingItems.length + 1 >= self.i && self.visibleItems.length < self.page) {
                is[i].show();
                self.visibleItems.push(is[i]);
                self.matchingItems.push(is[i]);
            } else if (is[i].matching()) {
                self.matchingItems.push(is[i]);
                is[i].hide();
            } else is[i].hide();
        }
        self.trigger('updated');
        return self;
    };
    init.start();
};

},{"1b434b5a9461d8e5":"ig0ut","a756cccd66af1725":"5Q8Wg","355c8271d6d86583":"bHCLy","2cf6256fc694ce82":"hawf6","8c38020246d086d2":"irj3Y","d07d13fdc6dfa6a7":"hcns2","b22749e10068855f":"cjG6u","ddb7a930ed4b98df":"13FpG","ab1cf05479417227":"hem3D","594d6336bb7bad00":"cOQ3E","644da385e1a4c8fe":"6QQ0q","640d9f0a2c0d9b81":"f4CH5","d999c75a1dca2c51":"kkDOO","165df06372153afc":"8eMZp","8c1b0467bbd8e450":"luUZE","2154e67e03c4e3ce":"6TzDc","62d0ae838d4b984c":"d3KXX","9b29ed0a6fd5d4b5":"T0PyF"}],"ig0ut":[function(require,module,exports,__globalThis) {
'use strict';
var alphabet;
var alphabetIndexMap;
var alphabetIndexMapLength = 0;
function isNumberCode(code) {
    return code >= 48 && code <= 57;
}
function naturalCompare(a, b) {
    var lengthA = (a += '').length;
    var lengthB = (b += '').length;
    var aIndex = 0;
    var bIndex = 0;
    while(aIndex < lengthA && bIndex < lengthB){
        var charCodeA = a.charCodeAt(aIndex);
        var charCodeB = b.charCodeAt(bIndex);
        if (isNumberCode(charCodeA)) {
            if (!isNumberCode(charCodeB)) return charCodeA - charCodeB;
            var numStartA = aIndex;
            var numStartB = bIndex;
            while(charCodeA === 48 && ++numStartA < lengthA)charCodeA = a.charCodeAt(numStartA);
            while(charCodeB === 48 && ++numStartB < lengthB)charCodeB = b.charCodeAt(numStartB);
            var numEndA = numStartA;
            var numEndB = numStartB;
            while(numEndA < lengthA && isNumberCode(a.charCodeAt(numEndA)))++numEndA;
            while(numEndB < lengthB && isNumberCode(b.charCodeAt(numEndB)))++numEndB;
            var difference = numEndA - numStartA - numEndB + numStartB; // numA length - numB length
            if (difference) return difference;
            while(numStartA < numEndA){
                difference = a.charCodeAt(numStartA++) - b.charCodeAt(numStartB++);
                if (difference) return difference;
            }
            aIndex = numEndA;
            bIndex = numEndB;
            continue;
        }
        if (charCodeA !== charCodeB) {
            if (charCodeA < alphabetIndexMapLength && charCodeB < alphabetIndexMapLength && alphabetIndexMap[charCodeA] !== -1 && alphabetIndexMap[charCodeB] !== -1) return alphabetIndexMap[charCodeA] - alphabetIndexMap[charCodeB];
            return charCodeA - charCodeB;
        }
        ++aIndex;
        ++bIndex;
    }
    if (aIndex >= lengthA && bIndex < lengthB && lengthA >= lengthB) return -1;
    if (bIndex >= lengthB && aIndex < lengthA && lengthB >= lengthA) return 1;
    return lengthA - lengthB;
}
naturalCompare.caseInsensitive = naturalCompare.i = function(a, b) {
    return naturalCompare(('' + a).toLowerCase(), ('' + b).toLowerCase());
};
Object.defineProperties(naturalCompare, {
    alphabet: {
        get: function() {
            return alphabet;
        },
        set: function(value) {
            alphabet = value;
            alphabetIndexMap = [];
            var i = 0;
            if (alphabet) for(; i < alphabet.length; i++)alphabetIndexMap[alphabet.charCodeAt(i)] = i;
            alphabetIndexMapLength = alphabetIndexMap.length;
            for(i = 0; i < alphabetIndexMapLength; i++)if (alphabetIndexMap[i] === undefined) alphabetIndexMap[i] = -1;
        }
    }
});
module.exports = naturalCompare;

},{}],"5Q8Wg":[function(require,module,exports,__globalThis) {
/**
 * A cross-browser implementation of getElementsByClass.
 * Heavily based on Dustin Diaz's function: http://dustindiaz.com/getelementsbyclass.
 *
 * Find all elements with class `className` inside `container`.
 * Use `single = true` to increase performance in older browsers
 * when only one element is needed.
 *
 * @param {String} className
 * @param {Element} container
 * @param {Boolean} single
 * @api public
 */ var getElementsByClassName = function(container, className, single) {
    if (single) return container.getElementsByClassName(className)[0];
    else return container.getElementsByClassName(className);
};
var querySelector = function(container, className, single) {
    className = '.' + className;
    if (single) return container.querySelector(className);
    else return container.querySelectorAll(className);
};
var polyfill = function(container, className, single) {
    var classElements = [], tag = '*';
    var els = container.getElementsByTagName(tag);
    var elsLen = els.length;
    var pattern = new RegExp('(^|\\s)' + className + '(\\s|$)');
    for(var i = 0, j = 0; i < elsLen; i++)if (pattern.test(els[i].className)) {
        if (single) return els[i];
        else {
            classElements[j] = els[i];
            j++;
        }
    }
    return classElements;
};
module.exports = function() {
    return function(container, className, single, options) {
        options = options || {};
        if (options.test && options.getElementsByClassName || !options.test && document.getElementsByClassName) return getElementsByClassName(container, className, single);
        else if (options.test && options.querySelector || !options.test && document.querySelector) return querySelector(container, className, single);
        else return polyfill(container, className, single);
    };
}();

},{}],"bHCLy":[function(require,module,exports,__globalThis) {
/*
 * Source: https://github.com/segmentio/extend
 */ module.exports = function extend(object) {
    // Takes an unlimited number of extenders.
    var args = Array.prototype.slice.call(arguments, 1);
    // For each extender, copy their properties on our object.
    for(var i = 0, source; source = args[i]; i++){
        if (!source) continue;
        for(var property in source)object[property] = source[property];
    }
    return object;
};

},{}],"hawf6":[function(require,module,exports,__globalThis) {
var indexOf = [].indexOf;
module.exports = function(arr, obj) {
    if (indexOf) return arr.indexOf(obj);
    for(var i = 0, il = arr.length; i < il; ++i){
        if (arr[i] === obj) return i;
    }
    return -1;
};

},{}],"irj3Y":[function(require,module,exports,__globalThis) {
var bind = window.addEventListener ? 'addEventListener' : 'attachEvent', unbind = window.removeEventListener ? 'removeEventListener' : 'detachEvent', prefix = bind !== 'addEventListener' ? 'on' : '', toArray = require("fde2defe7c113fd5");
/**
 * Bind `el` event `type` to `fn`.
 *
 * @param {Element} el, NodeList, HTMLCollection or Array
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @api public
 */ exports.bind = function(el, type, fn, capture) {
    el = toArray(el);
    for(var i = 0, il = el.length; i < il; i++)el[i][bind](prefix + type, fn, capture || false);
};
/**
 * Unbind `el` event `type`'s callback `fn`.
 *
 * @param {Element} el, NodeList, HTMLCollection or Array
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @api public
 */ exports.unbind = function(el, type, fn, capture) {
    el = toArray(el);
    for(var i = 0, il = el.length; i < il; i++)el[i][unbind](prefix + type, fn, capture || false);
};
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * `wait` milliseconds. If `immediate` is true, trigger the function on the
 * leading edge, instead of the trailing.
 *
 * @param {Function} fn
 * @param {Integer} wait
 * @param {Boolean} immediate
 * @api public
 */ exports.debounce = function(fn, wait, immediate) {
    var timeout;
    return wait ? function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) fn.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) fn.apply(context, args);
    } : fn;
};

},{"fde2defe7c113fd5":"hem3D"}],"hem3D":[function(require,module,exports,__globalThis) {
/**
 * Source: https://github.com/timoxley/to-array
 *
 * Convert an array-like object into an `Array`.
 * If `collection` is already an `Array`, then will return a clone of `collection`.
 *
 * @param {Array | Mixed} collection An `Array` or array-like object to convert e.g. `arguments` or `NodeList`
 * @return {Array} Naive conversion of `collection` to a new `Array`.
 * @api public
 */ module.exports = function toArray(collection) {
    if (typeof collection === 'undefined') return [];
    if (collection === null) return [
        null
    ];
    if (collection === window) return [
        window
    ];
    if (typeof collection === 'string') return [
        collection
    ];
    if (isArray(collection)) return collection;
    if (typeof collection.length != 'number') return [
        collection
    ];
    if (typeof collection === 'function' && collection instanceof Function) return [
        collection
    ];
    var arr = [];
    for(var i = 0, il = collection.length; i < il; i++)if (Object.prototype.hasOwnProperty.call(collection, i) || i in collection) arr.push(collection[i]);
    if (!arr.length) return [];
    return arr;
};
function isArray(arr) {
    return Object.prototype.toString.call(arr) === '[object Array]';
}

},{}],"hcns2":[function(require,module,exports,__globalThis) {
module.exports = function(s) {
    s = s === undefined ? '' : s;
    s = s === null ? '' : s;
    s = s.toString();
    return s;
};

},{}],"cjG6u":[function(require,module,exports,__globalThis) {
/**
 * Module dependencies.
 */ var index = require("33b4ac0437663324");
/**
 * Whitespace regexp.
 */ var re = /\s+/;
/**
 * toString reference.
 */ var toString = Object.prototype.toString;
/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */ module.exports = function(el) {
    return new ClassList(el);
};
/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */ function ClassList(el) {
    if (!el || !el.nodeType) throw new Error('A DOM element reference is required');
    this.el = el;
    this.list = el.classList;
}
/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */ ClassList.prototype.add = function(name) {
    // classList
    if (this.list) {
        this.list.add(name);
        return this;
    }
    // fallback
    var arr = this.array();
    var i = index(arr, name);
    if (!~i) arr.push(name);
    this.el.className = arr.join(' ');
    return this;
};
/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */ ClassList.prototype.remove = function(name) {
    // classList
    if (this.list) {
        this.list.remove(name);
        return this;
    }
    // fallback
    var arr = this.array();
    var i = index(arr, name);
    if (~i) arr.splice(i, 1);
    this.el.className = arr.join(' ');
    return this;
};
/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */ ClassList.prototype.toggle = function(name, force) {
    // classList
    if (this.list) {
        if ('undefined' !== typeof force) {
            if (force !== this.list.toggle(name, force)) this.list.toggle(name) // toggle again to correct
            ;
        } else this.list.toggle(name);
        return this;
    }
    // fallback
    if ('undefined' !== typeof force) {
        if (!force) this.remove(name);
        else this.add(name);
    } else if (this.has(name)) this.remove(name);
    else this.add(name);
    return this;
};
/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */ ClassList.prototype.array = function() {
    var className = this.el.getAttribute('class') || '';
    var str = className.replace(/^\s+|\s+$/g, '');
    var arr = str.split(re);
    if ('' === arr[0]) arr.shift();
    return arr;
};
/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */ ClassList.prototype.has = ClassList.prototype.contains = function(name) {
    return this.list ? this.list.contains(name) : !!~index(this.array(), name);
};

},{"33b4ac0437663324":"hawf6"}],"13FpG":[function(require,module,exports,__globalThis) {
/**
 * A cross-browser implementation of getAttribute.
 * Source found here: http://stackoverflow.com/a/3755343/361337 written by Vivin Paliath
 *
 * Return the value for `attr` at `element`.
 *
 * @param {Element} el
 * @param {String} attr
 * @api public
 */ module.exports = function(el, attr) {
    var result = el.getAttribute && el.getAttribute(attr) || null;
    if (!result) {
        var attrs = el.attributes;
        var length = attrs.length;
        for(var i = 0; i < length; i++){
            if (attrs[i] !== undefined) {
                if (attrs[i].nodeName === attr) result = attrs[i].nodeValue;
            }
        }
    }
    return result;
};

},{}],"cOQ3E":[function(require,module,exports,__globalThis) {
module.exports = function(list) {
    return function(initValues, element, notCreate) {
        var item = this;
        this._values = {};
        this.found = false // Show if list.searched == true and this.found == true
        ;
        this.filtered = false // Show if list.filtered == true and this.filtered == true
        ;
        var init = function(initValues, element, notCreate) {
            if (element === undefined) {
                if (notCreate) item.values(initValues, notCreate);
                else item.values(initValues);
            } else {
                item.elm = element;
                var values = list.templater.get(item, initValues);
                item.values(values);
            }
        };
        this.values = function(newValues, notCreate) {
            if (newValues !== undefined) {
                for(var name in newValues)item._values[name] = newValues[name];
                if (notCreate !== true) list.templater.set(item, item.values());
            } else return item._values;
        };
        this.show = function() {
            list.templater.show(item);
        };
        this.hide = function() {
            list.templater.hide(item);
        };
        this.matching = function() {
            return list.filtered && list.searched && item.found && item.filtered || list.filtered && !list.searched && item.filtered || !list.filtered && list.searched && item.found || !list.filtered && !list.searched;
        };
        this.visible = function() {
            return item.elm && item.elm.parentNode == list.list ? true : false;
        };
        init(initValues, element, notCreate);
    };
};

},{}],"6QQ0q":[function(require,module,exports,__globalThis) {
module.exports = function(list) {
    var addAsync = function(values, callback, items) {
        var valuesToAdd = values.splice(0, 50);
        items = items || [];
        items = items.concat(list.add(valuesToAdd));
        if (values.length > 0) setTimeout(function() {
            addAsync(values, callback, items);
        }, 1);
        else {
            list.update();
            callback(items);
        }
    };
    return addAsync;
};

},{}],"f4CH5":[function(require,module,exports,__globalThis) {
var classes = require("4815ab23fe9e6a22"), events = require("860515a7fba4089a"), List = require("468039887c1316ae");
module.exports = function(list) {
    var isHidden = false;
    var refresh = function(pagingList, options) {
        if (list.page < 1) {
            list.listContainer.style.display = 'none';
            isHidden = true;
            return;
        } else if (isHidden) list.listContainer.style.display = 'block';
        var item, l = list.matchingItems.length, index = list.i, page = list.page, pages = Math.ceil(l / page), currentPage = Math.ceil(index / page), innerWindow = options.innerWindow || 2, left = options.left || options.outerWindow || 0, right = options.right || options.outerWindow || 0;
        right = pages - right;
        pagingList.clear();
        for(var i = 1; i <= pages; i++){
            var className = currentPage === i ? 'active' : '';
            //console.log(i, left, right, currentPage, (currentPage - innerWindow), (currentPage + innerWindow), className);
            if (is.number(i, left, right, currentPage, innerWindow)) {
                item = pagingList.add({
                    page: i,
                    dotted: false
                })[0];
                if (className) classes(item.elm).add(className);
                item.elm.firstChild.setAttribute('data-i', i);
                item.elm.firstChild.setAttribute('data-page', page);
            } else if (is.dotted(pagingList, i, left, right, currentPage, innerWindow, pagingList.size())) {
                item = pagingList.add({
                    page: '...',
                    dotted: true
                })[0];
                classes(item.elm).add('disabled');
            }
        }
    };
    var is = {
        number: function(i, left, right, currentPage, innerWindow) {
            return this.left(i, left) || this.right(i, right) || this.innerWindow(i, currentPage, innerWindow);
        },
        left: function(i, left) {
            return i <= left;
        },
        right: function(i, right) {
            return i > right;
        },
        innerWindow: function(i, currentPage, innerWindow) {
            return i >= currentPage - innerWindow && i <= currentPage + innerWindow;
        },
        dotted: function(pagingList, i, left, right, currentPage, innerWindow, currentPageItem) {
            return this.dottedLeft(pagingList, i, left, right, currentPage, innerWindow) || this.dottedRight(pagingList, i, left, right, currentPage, innerWindow, currentPageItem);
        },
        dottedLeft: function(pagingList, i, left, right, currentPage, innerWindow) {
            return i == left + 1 && !this.innerWindow(i, currentPage, innerWindow) && !this.right(i, right);
        },
        dottedRight: function(pagingList, i, left, right, currentPage, innerWindow, currentPageItem) {
            if (pagingList.items[currentPageItem - 1].values().dotted) return false;
            else return i == right && !this.innerWindow(i, currentPage, innerWindow) && !this.right(i, right);
        }
    };
    return function(options) {
        var pagingList = new List(list.listContainer.id, {
            listClass: options.paginationClass || 'pagination',
            item: options.item || "<li><a class='page' href='#'></a></li>",
            valueNames: [
                'page',
                'dotted'
            ],
            searchClass: 'pagination-search-that-is-not-supposed-to-exist',
            sortClass: 'pagination-sort-that-is-not-supposed-to-exist'
        });
        events.bind(pagingList.listContainer, 'click', function(e) {
            var target = e.target || e.srcElement, page = list.utils.getAttribute(target, 'data-page'), i = list.utils.getAttribute(target, 'data-i');
            if (i) list.show((i - 1) * page + 1, page);
        });
        list.on('updated', function() {
            refresh(pagingList, options);
        });
        refresh(pagingList, options);
    };
};

},{"4815ab23fe9e6a22":"cjG6u","860515a7fba4089a":"irj3Y","468039887c1316ae":"2soMv"}],"kkDOO":[function(require,module,exports,__globalThis) {
module.exports = function(list) {
    var Item = require("19c0a806f3e85bc5")(list);
    var getChildren = function(parent) {
        var nodes = parent.childNodes, items = [];
        for(var i = 0, il = nodes.length; i < il; i++)// Only textnodes have a data attribute
        if (nodes[i].data === undefined) items.push(nodes[i]);
        return items;
    };
    var parse = function(itemElements, valueNames) {
        for(var i = 0, il = itemElements.length; i < il; i++)list.items.push(new Item(valueNames, itemElements[i]));
    };
    var parseAsync = function(itemElements, valueNames) {
        var itemsToIndex = itemElements.splice(0, 50) // TODO: If < 100 items, what happens in IE etc?
        ;
        parse(itemsToIndex, valueNames);
        if (itemElements.length > 0) setTimeout(function() {
            parseAsync(itemElements, valueNames);
        }, 1);
        else {
            list.update();
            list.trigger('parseComplete');
        }
    };
    list.handlers.parseComplete = list.handlers.parseComplete || [];
    return function() {
        var itemsToIndex = getChildren(list.list), valueNames = list.valueNames;
        if (list.indexAsync) parseAsync(itemsToIndex, valueNames);
        else parse(itemsToIndex, valueNames);
    };
};

},{"19c0a806f3e85bc5":"cOQ3E"}],"8eMZp":[function(require,module,exports,__globalThis) {
var Templater = function(list) {
    var createItem, templater = this;
    var init = function() {
        var itemSource;
        if (typeof list.item === 'function') {
            createItem = function(values) {
                var item = list.item(values);
                return getItemSource(item);
            };
            return;
        }
        if (typeof list.item === 'string') {
            if (list.item.indexOf('<') === -1) itemSource = document.getElementById(list.item);
            else itemSource = getItemSource(list.item);
        } else /* If item source does not exists, use the first item in list as
      source for new items */ itemSource = getFirstListItem();
        if (!itemSource) throw new Error("The list needs to have at least one item on init otherwise you'll have to add a template.");
        itemSource = createCleanTemplateItem(itemSource, list.valueNames);
        createItem = function() {
            return itemSource.cloneNode(true);
        };
    };
    var createCleanTemplateItem = function(templateNode, valueNames) {
        var el = templateNode.cloneNode(true);
        el.removeAttribute('id');
        for(var i = 0, il = valueNames.length; i < il; i++){
            var elm = undefined, valueName = valueNames[i];
            if (valueName.data) for(var j = 0, jl = valueName.data.length; j < jl; j++)el.setAttribute('data-' + valueName.data[j], '');
            else if (valueName.attr && valueName.name) {
                elm = list.utils.getByClass(el, valueName.name, true);
                if (elm) elm.setAttribute(valueName.attr, '');
            } else {
                elm = list.utils.getByClass(el, valueName, true);
                if (elm) elm.innerHTML = '';
            }
        }
        return el;
    };
    var getFirstListItem = function() {
        var nodes = list.list.childNodes;
        for(var i = 0, il = nodes.length; i < il; i++){
            // Only textnodes have a data attribute
            if (nodes[i].data === undefined) return nodes[i].cloneNode(true);
        }
        return undefined;
    };
    var getItemSource = function(itemHTML) {
        if (typeof itemHTML !== 'string') return undefined;
        if (/<tr[\s>]/g.exec(itemHTML)) {
            var tbody = document.createElement('tbody');
            tbody.innerHTML = itemHTML;
            return tbody.firstElementChild;
        } else if (itemHTML.indexOf('<') !== -1) {
            var div = document.createElement('div');
            div.innerHTML = itemHTML;
            return div.firstElementChild;
        }
        return undefined;
    };
    var getValueName = function(name) {
        for(var i = 0, il = list.valueNames.length; i < il; i++){
            var valueName = list.valueNames[i];
            if (valueName.data) {
                var data = valueName.data;
                for(var j = 0, jl = data.length; j < jl; j++){
                    if (data[j] === name) return {
                        data: name
                    };
                }
            } else if (valueName.attr && valueName.name && valueName.name == name) return valueName;
            else if (valueName === name) return name;
        }
    };
    var setValue = function(item, name, value) {
        var elm = undefined, valueName = getValueName(name);
        if (!valueName) return;
        if (valueName.data) item.elm.setAttribute('data-' + valueName.data, value);
        else if (valueName.attr && valueName.name) {
            elm = list.utils.getByClass(item.elm, valueName.name, true);
            if (elm) elm.setAttribute(valueName.attr, value);
        } else {
            elm = list.utils.getByClass(item.elm, valueName, true);
            if (elm) elm.innerHTML = value;
        }
    };
    this.get = function(item, valueNames) {
        templater.create(item);
        var values = {};
        for(var i = 0, il = valueNames.length; i < il; i++){
            var elm = undefined, valueName = valueNames[i];
            if (valueName.data) for(var j = 0, jl = valueName.data.length; j < jl; j++)values[valueName.data[j]] = list.utils.getAttribute(item.elm, 'data-' + valueName.data[j]);
            else if (valueName.attr && valueName.name) {
                elm = list.utils.getByClass(item.elm, valueName.name, true);
                values[valueName.name] = elm ? list.utils.getAttribute(elm, valueName.attr) : '';
            } else {
                elm = list.utils.getByClass(item.elm, valueName, true);
                values[valueName] = elm ? elm.innerHTML : '';
            }
        }
        return values;
    };
    this.set = function(item, values) {
        if (!templater.create(item)) {
            for(var v in values)if (values.hasOwnProperty(v)) setValue(item, v, values[v]);
        }
    };
    this.create = function(item) {
        if (item.elm !== undefined) return false;
        item.elm = createItem(item.values());
        templater.set(item, item.values());
        return true;
    };
    this.remove = function(item) {
        if (item.elm.parentNode === list.list) list.list.removeChild(item.elm);
    };
    this.show = function(item) {
        templater.create(item);
        list.list.appendChild(item.elm);
    };
    this.hide = function(item) {
        if (item.elm !== undefined && item.elm.parentNode === list.list) list.list.removeChild(item.elm);
    };
    this.clear = function() {
        /* .innerHTML = ''; fucks up IE */ if (list.list.hasChildNodes()) while(list.list.childNodes.length >= 1)list.list.removeChild(list.list.firstChild);
    };
    init();
};
module.exports = function(list) {
    return new Templater(list);
};

},{}],"luUZE":[function(require,module,exports,__globalThis) {
module.exports = function(list) {
    var item, text, columns, searchString, customSearch;
    var prepare = {
        resetList: function() {
            list.i = 1;
            list.templater.clear();
            customSearch = undefined;
        },
        setOptions: function(args) {
            if (args.length == 2 && args[1] instanceof Array) columns = args[1];
            else if (args.length == 2 && typeof args[1] == 'function') {
                columns = undefined;
                customSearch = args[1];
            } else if (args.length == 3) {
                columns = args[1];
                customSearch = args[2];
            } else columns = undefined;
        },
        setColumns: function() {
            if (list.items.length === 0) return;
            if (columns === undefined) columns = list.searchColumns === undefined ? prepare.toArray(list.items[0].values()) : list.searchColumns;
        },
        setSearchString: function(s) {
            s = list.utils.toString(s).toLowerCase();
            s = s.replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&') // Escape regular expression characters
            ;
            searchString = s;
        },
        toArray: function(values) {
            var tmpColumn = [];
            for(var name in values)tmpColumn.push(name);
            return tmpColumn;
        }
    };
    var search = {
        list: function() {
            // Extract quoted phrases "word1 word2" from original searchString
            // searchString is converted to lowercase by List.js
            var words = [], phrase, ss = searchString;
            while((phrase = ss.match(/"([^"]+)"/)) !== null){
                words.push(phrase[1]);
                ss = ss.substring(0, phrase.index) + ss.substring(phrase.index + phrase[0].length);
            }
            // Get remaining space-separated words (if any)
            ss = ss.trim();
            if (ss.length) words = words.concat(ss.split(/\s+/));
            for(var k = 0, kl = list.items.length; k < kl; k++){
                var item = list.items[k];
                item.found = false;
                if (!words.length) continue;
                for(var i = 0, il = words.length; i < il; i++){
                    var word_found = false;
                    for(var j = 0, jl = columns.length; j < jl; j++){
                        var values = item.values(), column = columns[j];
                        if (values.hasOwnProperty(column) && values[column] !== undefined && values[column] !== null) {
                            var text = typeof values[column] !== 'string' ? values[column].toString() : values[column];
                            if (text.toLowerCase().indexOf(words[i]) !== -1) {
                                // word found, so no need to check it against any other columns
                                word_found = true;
                                break;
                            }
                        }
                    }
                    // this word not found? no need to check any other words, the item cannot match
                    if (!word_found) break;
                }
                item.found = word_found;
            }
        },
        // Removed search.item() and search.values()
        reset: function() {
            list.reset.search();
            list.searched = false;
        }
    };
    var searchMethod = function(str) {
        list.trigger('searchStart');
        prepare.resetList();
        prepare.setSearchString(str);
        prepare.setOptions(arguments) // str, cols|searchFunction, searchFunction
        ;
        prepare.setColumns();
        if (searchString === '') search.reset();
        else {
            list.searched = true;
            if (customSearch) customSearch(searchString, columns);
            else search.list();
        }
        list.update();
        list.trigger('searchComplete');
        return list.visibleItems;
    };
    list.handlers.searchStart = list.handlers.searchStart || [];
    list.handlers.searchComplete = list.handlers.searchComplete || [];
    list.utils.events.bind(list.utils.getByClass(list.listContainer, list.searchClass), 'keyup', list.utils.events.debounce(function(e) {
        var target = e.target || e.srcElement, alreadyCleared = target.value === '' && !list.searched;
        if (!alreadyCleared) // If oninput already have resetted the list, do nothing
        searchMethod(target.value);
    }, list.searchDelay));
    // Used to detect click on HTML5 clear button
    list.utils.events.bind(list.utils.getByClass(list.listContainer, list.searchClass), 'input', function(e) {
        var target = e.target || e.srcElement;
        if (target.value === '') searchMethod('');
    });
    return searchMethod;
};

},{}],"6TzDc":[function(require,module,exports,__globalThis) {
module.exports = function(list) {
    // Add handlers
    list.handlers.filterStart = list.handlers.filterStart || [];
    list.handlers.filterComplete = list.handlers.filterComplete || [];
    return function(filterFunction) {
        list.trigger('filterStart');
        list.i = 1 // Reset paging
        ;
        list.reset.filter();
        if (filterFunction === undefined) list.filtered = false;
        else {
            list.filtered = true;
            var is = list.items;
            for(var i = 0, il = is.length; i < il; i++){
                var item = is[i];
                if (filterFunction(item)) item.filtered = true;
                else item.filtered = false;
            }
        }
        list.update();
        list.trigger('filterComplete');
        return list.visibleItems;
    };
};

},{}],"d3KXX":[function(require,module,exports,__globalThis) {
module.exports = function(list) {
    var buttons = {
        els: undefined,
        clear: function() {
            for(var i = 0, il = buttons.els.length; i < il; i++){
                list.utils.classes(buttons.els[i]).remove('asc');
                list.utils.classes(buttons.els[i]).remove('desc');
            }
        },
        getOrder: function(btn) {
            var predefinedOrder = list.utils.getAttribute(btn, 'data-order');
            if (predefinedOrder == 'asc' || predefinedOrder == 'desc') return predefinedOrder;
            else if (list.utils.classes(btn).has('desc')) return 'asc';
            else if (list.utils.classes(btn).has('asc')) return 'desc';
            else return 'asc';
        },
        getInSensitive: function(btn, options) {
            var insensitive = list.utils.getAttribute(btn, 'data-insensitive');
            if (insensitive === 'false') options.insensitive = false;
            else options.insensitive = true;
        },
        setOrder: function(options) {
            for(var i = 0, il = buttons.els.length; i < il; i++){
                var btn = buttons.els[i];
                if (list.utils.getAttribute(btn, 'data-sort') !== options.valueName) continue;
                var predefinedOrder = list.utils.getAttribute(btn, 'data-order');
                if (predefinedOrder == 'asc' || predefinedOrder == 'desc') {
                    if (predefinedOrder == options.order) list.utils.classes(btn).add(options.order);
                } else list.utils.classes(btn).add(options.order);
            }
        }
    };
    var sort = function() {
        list.trigger('sortStart');
        var options = {};
        var target = arguments[0].currentTarget || arguments[0].srcElement || undefined;
        if (target) {
            options.valueName = list.utils.getAttribute(target, 'data-sort');
            buttons.getInSensitive(target, options);
            options.order = buttons.getOrder(target);
        } else {
            options = arguments[1] || options;
            options.valueName = arguments[0];
            options.order = options.order || 'asc';
            options.insensitive = typeof options.insensitive == 'undefined' ? true : options.insensitive;
        }
        buttons.clear();
        buttons.setOrder(options);
        // caseInsensitive
        // alphabet
        var customSortFunction = options.sortFunction || list.sortFunction || null, multi = options.order === 'desc' ? -1 : 1, sortFunction;
        if (customSortFunction) sortFunction = function(itemA, itemB) {
            return customSortFunction(itemA, itemB, options) * multi;
        };
        else sortFunction = function(itemA, itemB) {
            var sort = list.utils.naturalSort;
            sort.alphabet = list.alphabet || options.alphabet || undefined;
            if (!sort.alphabet && options.insensitive) sort = list.utils.naturalSort.caseInsensitive;
            return sort(itemA.values()[options.valueName], itemB.values()[options.valueName]) * multi;
        };
        list.items.sort(sortFunction);
        list.update();
        list.trigger('sortComplete');
    };
    // Add handlers
    list.handlers.sortStart = list.handlers.sortStart || [];
    list.handlers.sortComplete = list.handlers.sortComplete || [];
    buttons.els = list.utils.getByClass(list.listContainer, list.sortClass);
    list.utils.events.bind(buttons.els, 'click', sort);
    list.on('searchStart', buttons.clear);
    list.on('filterStart', buttons.clear);
    return sort;
};

},{}],"T0PyF":[function(require,module,exports,__globalThis) {
var classes = require("52e98d7f23589857"), events = require("56c43af4a6a09fb4"), extend = require("e0bf7f062a411994"), toString = require("a4903deeb557603c"), getByClass = require("be51485f96398f17"), fuzzy = require("30aea493a0219497");
module.exports = function(list, options) {
    options = options || {};
    options = extend({
        location: 0,
        distance: 100,
        threshold: 0.4,
        multiSearch: true,
        searchClass: 'fuzzy-search'
    }, options);
    var fuzzySearch = {
        search: function(searchString, columns) {
            // Substract arguments from the searchString or put searchString as only argument
            var searchArguments = options.multiSearch ? searchString.replace(/ +$/, '').split(/ +/) : [
                searchString
            ];
            for(var k = 0, kl = list.items.length; k < kl; k++)fuzzySearch.item(list.items[k], columns, searchArguments);
        },
        item: function(item, columns, searchArguments) {
            var found = true;
            for(var i = 0; i < searchArguments.length; i++){
                var foundArgument = false;
                for(var j = 0, jl = columns.length; j < jl; j++)if (fuzzySearch.values(item.values(), columns[j], searchArguments[i])) foundArgument = true;
                if (!foundArgument) found = false;
            }
            item.found = found;
        },
        values: function(values, value, searchArgument) {
            if (values.hasOwnProperty(value)) {
                var text = toString(values[value]).toLowerCase();
                if (fuzzy(text, searchArgument, options)) return true;
            }
            return false;
        }
    };
    events.bind(getByClass(list.listContainer, options.searchClass), 'keyup', list.utils.events.debounce(function(e) {
        var target = e.target || e.srcElement // IE have srcElement
        ;
        list.search(target.value, fuzzySearch.search);
    }, list.searchDelay));
    return function(str, columns) {
        list.search(str, columns, fuzzySearch.search);
    };
};

},{"52e98d7f23589857":"cjG6u","56c43af4a6a09fb4":"irj3Y","e0bf7f062a411994":"bHCLy","a4903deeb557603c":"hcns2","be51485f96398f17":"5Q8Wg","30aea493a0219497":"9DqaW"}],"9DqaW":[function(require,module,exports,__globalThis) {
module.exports = function(text, pattern, options) {
    // Aproximately where in the text is the pattern expected to be found?
    var Match_Location = options.location || 0;
    //Determines how close the match must be to the fuzzy location (specified above). An exact letter match which is 'distance' characters away from the fuzzy location would score as a complete mismatch. A distance of '0' requires the match be at the exact location specified, a threshold of '1000' would require a perfect match to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    var Match_Distance = options.distance || 100;
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match (of both letters and location), a threshold of '1.0' would match anything.
    var Match_Threshold = options.threshold || 0.4;
    if (pattern === text) return true // Exact match
    ;
    if (pattern.length > 32) return false // This algorithm cannot be used
    ;
    // Set starting location at beginning text and initialise the alphabet.
    var loc = Match_Location, s = function() {
        var q = {}, i;
        for(i = 0; i < pattern.length; i++)q[pattern.charAt(i)] = 0;
        for(i = 0; i < pattern.length; i++)q[pattern.charAt(i)] |= 1 << pattern.length - i - 1;
        return q;
    }();
    // Compute and return the score for a match with e errors and x location.
    // Accesses loc and pattern through being a closure.
    function match_bitapScore_(e, x) {
        var accuracy = e / pattern.length, proximity = Math.abs(loc - x);
        if (!Match_Distance) // Dodge divide by zero error.
        return proximity ? 1.0 : accuracy;
        return accuracy + proximity / Match_Distance;
    }
    var score_threshold = Match_Threshold, best_loc = text.indexOf(pattern, loc) // Is there a nearby exact match? (speedup)
    ;
    if (best_loc != -1) {
        score_threshold = Math.min(match_bitapScore_(0, best_loc), score_threshold);
        // What about in the other direction? (speedup)
        best_loc = text.lastIndexOf(pattern, loc + pattern.length);
        if (best_loc != -1) score_threshold = Math.min(match_bitapScore_(0, best_loc), score_threshold);
    }
    // Initialise the bit arrays.
    var matchmask = 1 << pattern.length - 1;
    best_loc = -1;
    var bin_min, bin_mid;
    var bin_max = pattern.length + text.length;
    var last_rd;
    for(var d = 0; d < pattern.length; d++){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from 'loc' we can stray at this
        // error level.
        bin_min = 0;
        bin_mid = bin_max;
        while(bin_min < bin_mid){
            if (match_bitapScore_(d, loc + bin_mid) <= score_threshold) bin_min = bin_mid;
            else bin_max = bin_mid;
            bin_mid = Math.floor((bin_max - bin_min) / 2 + bin_min);
        }
        // Use the result from this iteration as the maximum for the next.
        bin_max = bin_mid;
        var start = Math.max(1, loc - bin_mid + 1);
        var finish = Math.min(loc + bin_mid, text.length) + pattern.length;
        var rd = Array(finish + 2);
        rd[finish + 1] = (1 << d) - 1;
        for(var j = finish; j >= start; j--){
            // The alphabet (s) is a sparse hash, so the following line generates
            // warnings.
            var charMatch = s[text.charAt(j - 1)];
            if (d === 0) // First pass: exact match.
            rd[j] = (rd[j + 1] << 1 | 1) & charMatch;
            else // Subsequent passes: fuzzy match.
            rd[j] = (rd[j + 1] << 1 | 1) & charMatch | ((last_rd[j + 1] | last_rd[j]) << 1 | 1) | last_rd[j + 1];
            if (rd[j] & matchmask) {
                var score = match_bitapScore_(d, j - 1);
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (score <= score_threshold) {
                    // Told you so.
                    score_threshold = score;
                    best_loc = j - 1;
                    if (best_loc > loc) // When passing loc, don't exceed our current distance from loc.
                    start = Math.max(1, 2 * loc - best_loc);
                    else break;
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        if (match_bitapScore_(d + 1, loc) > score_threshold) break;
        last_rd = rd;
    }
    return best_loc < 0 ? false : true;
};

},{}],"i6S27":[function(require,module,exports,__globalThis) {
var isObject = require("3b174a999d6a40ac"), now = require("575b2317167ce20d"), toNumber = require("a13332670c5c0f63");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    wait = toNumber(wait) || 0;
    if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge(now());
    }
    function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = debounce;

},{"3b174a999d6a40ac":"bGrJ0","575b2317167ce20d":"f290F","a13332670c5c0f63":"cX4IX"}],"bGrJ0":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = isObject;

},{}],"f290F":[function(require,module,exports,__globalThis) {
var root = require("6439589d9d88d885");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function() {
    return root.Date.now();
};
module.exports = now;

},{"6439589d9d88d885":"3EyEE"}],"3EyEE":[function(require,module,exports,__globalThis) {
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
module.exports = root;

},{"cd92e8811deaabf5":"c6Eem"}],"c6Eem":[function(require,module,exports,__globalThis) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"cX4IX":[function(require,module,exports,__globalThis) {
var baseTrim = require("261e89907fb89d78"), isObject = require("faaa289d287a34a5"), isSymbol = require("47b3bd23f771891");
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == 'number') return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = toNumber;

},{"261e89907fb89d78":"4sedN","faaa289d287a34a5":"bGrJ0","47b3bd23f771891":"3Mt4F"}],"4sedN":[function(require,module,exports,__globalThis) {
var trimmedEndIndex = require("985d3c9be7b51937");
/** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}
module.exports = baseTrim;

},{"985d3c9be7b51937":"ezIBK"}],"ezIBK":[function(require,module,exports,__globalThis) {
/** Used to match a single whitespace character. */ var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = trimmedEndIndex;

},{}],"3Mt4F":[function(require,module,exports,__globalThis) {
var baseGetTag = require("6118c0d5630f51ce"), isObjectLike = require("74644060ad1a1d3c");
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"6118c0d5630f51ce":"fhw5y","74644060ad1a1d3c":"kGZ3D"}],"fhw5y":[function(require,module,exports,__globalThis) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"ktyzg","9b2aaf31b7bdd837":"8kdZ4","46d5beb3375f8a28":"dmlO3"}],"ktyzg":[function(require,module,exports,__globalThis) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"3EyEE"}],"8kdZ4":[function(require,module,exports,__globalThis) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"ktyzg"}],"dmlO3":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"kGZ3D":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = isObjectLike;

},{}],"7rQxk":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}]},["lWo2u"], "lWo2u", "parcelRequireef34", {})

//# sourceMappingURL=search-modal.js.map
